import React from 'react';
import {imagePropsTitle, imageProps, limitTime} from './data';
import * as S from './style';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container, Image} from '../../../Components/Atom';
import {ContentTitle} from '../../../Components/Organism';
import {expiredIMG} from '../../../config/images';
import styled from 'styled-components';
import {viewSize, colorPalette} from '../../../config';

export const ExpiredImg = styled.img`
	display: block;
	margin: 0 auto;
	width: 50%;
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;

export const ExpiredText = styled.div`
	color: ${colorPalette.primary};
	font-family: 'Gmarket';
	font-size: 35px;
	font-weight: 600;
	text-align: center;
	@media screen and (max-width: ${viewSize.mobile}) {
		font-size: 20px;
	}
`;

const Course = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회코스']} />
			<S.Container>
				{/* <ExpiredImg src={expiredIMG} />
				<ExpiredText>준비중입니다.</ExpiredText> */}
				<S.ImgWrapper>
					<ContentTitle {...imageProps.title} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course} />
					</S.CardWrapper>
					{/* <div style={{marginTop: '60px'}}></div>
					<ContentTitle {...imageProps.title1} />
					<div style={{marginTop: '30px'}}></div>
					<S.CardWrapper>
						<Image {...imageProps.course1} />
					</S.CardWrapper> */}
				</S.ImgWrapper>
				{/* <S.CardWrapper>
					<CardSection {...limitTime} />
				</S.CardWrapper> */}
			</S.Container>
		</Container>
	);
};

export default Course;
